export interface IApplicationInProgressQuestion {
  question?: string;
  answer: string | number | boolean | Record<string, any>;
  key: string;
}

export enum ApplicationFormPageEnum {
  ADD_ADDRESS = 'ADD_ADDRESS',
  ADD_CARD = 'ADD_CARD',
  ADD_STUDENT_LOAN = 'ADD_STUDENT_LOAN',
  ADDITIONAL_NOTES = 'ADDITIONAL_NOTES',
  ADDRESS_HISTORY = 'ADDRESS_HISTORY',
  APPLICATION_TYPE = 'APPLICATION_TYPE',
  BASIS = 'BASIS',
  BENEFITS_AND_CREDITS = 'BENEFITS_AND_CREDITS',
  BONUS_AND_COMMISSIONS = 'BONUS_AND_COMMISSIONS',
  CARDS = 'CARDS',
  CONTACT_DETAILS = 'CONTACT_DETAILS',
  CRITERIA = 'CRITERIA',
  DEPENDANTS = 'DEPENDANTS',
  EMPLOYMENT = 'EMPLOYMENT',
  EMPLOYMENT_TENURE = 'EMPLOYMENT_TENURE',
  FULL_NAME = 'FULL_NAME',
  HOUSEHOLD_OUTGOINGS = 'HOUSEHOLD_OUTGOINGS',
  HOUSEHOLD_SPENDINGS = 'HOUSEHOLD_SPENDINGS',
  INCOME = 'INCOME',
  INDUSTRY_AND_ROLE = 'INDUSTRY_AND_ROLE',
  INTERMEDIARY_FEES = 'INTERMEDIARY_FEES',
  INTRODUCER = 'INTRODUCER',
  INTRODUCTION = 'INTRODUCTION',
  LOAN_REPAYMENTS = 'LOAN_REPAYMENTS',
  OTHER_INCOME = 'OTHER_INCOME',
  PARTNER_ADDRESS_HISTORY = 'PARTNER_ADDRESS_HISTORY',
  PERSONAL_DETAILS = 'PERSONAL_DETAILS',
  PREVIOUS_NAME = 'PREVIOUS_NAME',
  PURCHASE = 'PURCHASE',
  REFINANCING = 'REFINANCING',
  REGION = 'REGION',
  RELATIONSHIP = 'RELATIONSHIP',
  RESIDENCY = 'RESIDENCY',
  REVIEW_AND_SUBMIT = 'REVIEW_AND_SUBMIT',
  SECOND_JOB = 'SECOND_JOB',
  STUDENT_LOANS = 'STUDENT_LOANS',
  SUBMISSION = 'SUBMISSION',
  TRAVEL_EXPENSES = 'TRAVEL_EXPENSES',
  IN_REVIEW = 'IN_REVIEW',
}
